// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 28) return "static/js/c86ae19d50ed260c39a2.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"7e8f69bb56ef594bb93f","150":"0bb070ce00c62de51c0e","151":"3711a223689612cd261c"}[chunkId] + ".chunk.js";
};